"use client"

import * as React from "react"
import { useThemeTransition } from "@/provider/theme-provider"
import { MoonIcon, SunIcon } from "lucide-react"

import { useMounted } from "@/hooks/use-mounted"

export function ThemeToggle() {
  const { toggleTheme } = useThemeTransition()
  const isMounted = useMounted()

  const handleToggle = React.useCallback(
    (event: React.MouseEvent<HTMLButtonElement>) => {
      const rect = event.currentTarget.getBoundingClientRect()
      toggleTheme({
        x: rect.left + rect.width / 2,
        y: rect.top + rect.height / 2,
      })
    },
    [toggleTheme]
  )

  if (!isMounted) {
    return (
      <button
        className="text-primary bg-primary/5 hover:bg-primary/10 cursor-pointer rounded-lg p-2 transition-colors"
        aria-label="Toggle theme"
        disabled
      >
        <span className="sr-only">Toggle theme</span>
      </button>
    )
  }

  return (
    <button
      onClick={handleToggle}
      className="text-primary bg-primary/5 hover:bg-primary/10 cursor-pointer rounded-lg p-2 transition-colors"
    >
      <SunIcon className="hidden h-4 w-4 [html.dark_&]:block" />
      <MoonIcon className="hidden h-4 w-4 [html.light_&]:block" />
      <span className="sr-only">Toggle theme</span>
    </button>
  )
}
